import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-survey-feedback-modal',
  templateUrl: './survey-feedback-modal.component.html',
  styleUrls: ['./survey-feedback-modal.component.scss']
})
export class SurveyFeedbackModalComponent {
  @Output() startSurvey = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  onStartSurvey() {
    this.startSurvey.emit();
    this.activeModal.close('start');
  }

  onNotNow() {
    this.activeModal.close('cancel');
  }
} 